// @flow
import {
    setItem,
    SEARCH_FAILS_COUNT,
    getSearchRetriesLeft,
    resetSearchFailsSessionPayload
} from '../../utils/sessionStorage';

import type {Store} from '../../reducers/index';
import type {SearchRequestQueryCompleteAction} from '../../actions/searchRequestQuery';

export default function trackSearchOopsReload(
    store: Store,
    {payload}: SearchRequestQueryCompleteAction
) {
    const retriesLeft = getSearchRetriesLeft();

    if (payload.results || retriesLeft < 0) {
        resetSearchFailsSessionPayload();
    } else {
        setItem(SEARCH_FAILS_COUNT, `${retriesLeft - 1}`);
    }
}
